<template>
    <div class="d-flex w-100">
      <div v-if="!details" class="d-flex w-100">
        <div class="col-md-3">
          <templateFilter :TipoQmaTemplate="TipoQmaTemplate" @search="search"></templateFilter>
        </div>
        <div class="col-md-9">
            <templateTable ref="tablepit" @templateQMADetalhes="templateQMADetalhes"></templateTable>
        </div>
      </div>
      <div v-if="details" class="d-flex w-100">
        <div class="col-md-3">
          <panelTemplate ref="painel" :templateid="templateid"></panelTemplate>
        </div>
        <div class="col-md-9">
          <tabsTemplate @atualizaPainel="atualizaPainel" :tipoTemplate="tipoTemplate" :templateid="templateid"></tabsTemplate>
        </div>
      </div>
    </div>
  </template>

<script>
import templateQmaPIT from './templateQmaPIT'
export default templateQmaPIT

</script>

  <style scoped>
   .col-md-3{
    padding-right: 0;
    padding-left: 0;
   }
</style>



// WEBPACK FOOTER //
// src/views/private/qma/qmaTemplate/templateQmaPIT/templateQmaPIT.vue